import { parseISO } from 'date-fns'

import { CellRendererParams } from '../EntityTable/types'
import { Badge } from '@/Atomic/Atoms/Badge'
import { StringText } from '@/Atomic/Atoms/StringText'
import { ensureString } from '@/utils/ensureString'
import { formatDateTime } from '@/utils/formatDateTime'
import { formatDurationShort } from '@/utils/formatDuration'

import './ActivityTimelineCell.scss'

export const ActivityTimelineCell = ({ dataItem }: CellRendererParams) => {
  const beginAt = dataItem.get('beginAt')
  const endAt = dataItem.get('endAt')

  if (!beginAt && !endAt) {
    return <div className="timeline-begin-end-duration">-</div>
  }

  const duration = formatDurationShort(
    parseISO(ensureString(beginAt)),
    parseISO(ensureString(endAt)),
    3,
  )
  return (
    <div className="timeline-begin-end-duration">
      <div className="timeline-begin-end">
        <StringText>{formatDateTime(beginAt)}</StringText>
        <StringText>{formatDateTime(endAt)}</StringText>
      </div>
      {duration && <Badge variant="white" value={duration} />}
    </div>
  )
}
